module.exports = __webpack_public_path__ + "static/img/2-04.1c8ae40.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-04.png
// module id = 221
// module chunks = 0